import { Controller } from "@hotwired/stimulus"

// Cookie-acceptance banner shown until the user clicks accept. Sets a
// year-long cookie and removes the controller's root element.
//
// Usage:
//   <section class="b-cookie" data-controller="cookie-consent">
//     …text…
//     <button data-action="click->cookie-consent#accept">OK</button>
//   </section>
export default class extends Controller {
  static values = {
    cookieName: { type: String, default: "user-accept-cookies" }
  }

  accept() {
    const date = new Date()
    date.setFullYear(date.getFullYear() + 1)
    const value = encodeURIComponent(date.toUTCString())
    document.cookie = `${this.cookieNameValue}=${value}; expires=${date.toUTCString()}; path=/`
    this.element.remove()
  }
}
